
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const RegistrationSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { schoolName, schoolEmail, regCode, adminEmail, adminPassword } = location.state || {};

  useEffect(() => {
    if (!schoolName) {
      // If no state, redirect to register
      navigate('/register');
    }
  }, [schoolName, navigate]);

  if (!schoolName) return null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-blue-50 py-12">
      <div className="max-w-2xl w-full mx-4 space-y-8 p-8 bg-white rounded-2xl shadow-xl">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <i className="fas fa-check-circle text-3xl text-green-600"></i>
            </div>
          </div>
          <h2 className="text-3xl font-bold text-gray-900">Registration Successful!</h2>
          <p className="mt-2 text-gray-600">
            Your school account has been created. We've sent a welcome email with your login details.
          </p>
          <p className="mt-1 text-sm text-primary-600 font-medium">
            You can log in at <span className="font-mono bg-gray-100 px-2 py-1 rounded">/login</span> using your admin credentials below.
          </p>
        </div>

        <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Registration Details</h3>
          <div className="space-y-3">
            <div className="flex justify-between py-2 border-b border-gray-200">
              <span className="font-medium text-gray-600">School Name:</span>
              <span className="text-gray-900">{schoolName}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-gray-200">
              <span className="font-medium text-gray-600">School Email:</span>
              <span className="text-gray-900">{schoolEmail}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-gray-200">
              <span className="font-medium text-gray-600">Registration Code:</span>
              <span className="text-gray-900 font-mono">{regCode}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-gray-200">
              <span className="font-medium text-gray-600">Admin Email:</span>
              <span className="text-gray-900">{adminEmail}</span>
            </div>
            <div className="flex justify-between py-2">
              <span className="font-medium text-gray-600">Admin Password:</span>
              <span className="text-gray-900 font-mono">{adminPassword}</span>
            </div>
          </div>
          <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-sm text-yellow-800">
            <i className="fas fa-info-circle mr-2"></i>
            Please save these credentials. You'll need them to log in.
          </div>
        </div>

        <div className="flex justify-center space-x-4">
          <button
            onClick={() => navigate('/login')}
            className="px-6 py-3 border-gray-300 bg-primary-600 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Go to Login
          </button>
          <button
            onClick={() => window.print()}
            className="px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
          >
            <i className="fas fa-print mr-2"></i>
            Print Details
          </button>
        </div>

        <p className="text-sm text-gray-500 text-center">
          An email has been sent to <strong>{adminEmail}</strong> with these details.
        </p>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
